// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-bordered > .panel-heading[data-v-68c6149c] {\n  padding-top: 15px;\n}\n.panel-bordered > .panel-heading > .panel-title[data-v-68c6149c] {\n  padding-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n}", ""]);
// Exports
module.exports = exports;
